import { useEffect, useState } from 'react';

type SSLStatus = 'ok' | 'warning' | 'error';

export function useSSLCheck() {
  const [status, setStatus] = useState<SSLStatus>('ok');

  const endpoint = process.env.REACT_APP_API_URL as string;

  useEffect(() => {
    const checkSSL = async () => {
      // Check if current site is using HTTPS
      if (window.location.protocol !== 'https:') {
        setStatus('warning');
        return;
      }

      try {
        const res = await fetch(endpoint, {
          method: 'HEAD',
          mode: 'no-cors',
        });

        // If we get here, SSL probably succeeded
        setStatus('ok');
      } catch (error) {
        setStatus('error');
      }
    };

    checkSSL();
  }, [endpoint]);

  return status;
}
